import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { packagesService } from '../../services/packages.service';

@Component({
  selector: 'app-packages-section',
  templateUrl: './packages-section.component.html',
  styleUrls: ['./packages-section.component.scss'],
  standalone: false,
})
export class PackagesSectionComponent implements OnInit {


  pacakges = [];
  constructor(
    private router: Router,
    private packagesService: packagesService
  ){

  }

  ngOnInit(): void {
    this.packagesService.packages$.subscribe(res => {
     this.pacakges = res;
    })
    
  }

  joinNow(value:string){
    this.router.navigate(['/user/join'], { queryParams: { package: value } });
  }
}
